/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { ContentController, ContentControllerType } from '.'
 */

/**
 * TODO: možná by se hodil nějaký piktogram, že není žádný obsah
 * @implements {ContentController}
 */
export class EmptyContentController {
  constructor() {
    /** @type {ContentControllerType} */
    this.type = 'empty';
  }

  /** @type {ContentController['off']} */
  off(...args) {}

  /** @type {ContentController['on']} */
  on(...args) {}

  /** @type {ContentController['preload']} */
  async preload() {}

  /** @type {ContentController['restart']} */
  async restart() {}

  /** @type {ContentController['start']} */
  async start(offsetMs) {}

  /** @type {ContentController['stop']} */
  async stop() {}
}
